module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/move_2.f10c97ef.png";